/**
 * Tutorial guidato delle impostazioni Statistiche.
 *
 * Un preparativo solo: il riquadro di Google Map, che il passo dedicato apre per
 * mostrarne i campi. `stopStatsSettingsTour` lo richiude a fine giro, e solo se ad
 * aprirlo e' stato il tutorial. Gli interruttori non si toccano: salvano subito.
 */
const SCOPE = '[data-tour-scope="setting-stats"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopStatsSettingsTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createStatsSettingsTourSteps() {
	return [
		{
			body: 'Qui si collegano i servizi Google che portano numeri dentro il gestionale: le mappe, che servono al negozio e alle recensioni, e Analytics, da cui arrivano le visite del sito nella pagina Statistiche.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I servizi di statistica',
		},
		{
			body: "Un servizio per riga, con il suo interruttore. Acceso vuol dire che il gestionale prova a usarlo: se le credenziali non sono a posto, il servizio risponde con un errore invece che con i dati. L'interruttore salva subito.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere un servizio',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione. Per le mappe servono la chiave API e l'identificativo del luogo, che si ottengono dalla console di Google; per Analytics il file JSON delle credenziali e l'identificativo della proprieta'.",
			before: stopStatsSettingsTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: 'I campi si compilano con quello che Google ha rilasciato e si confermano con Salva, qui dentro. Il pulsante salva il servizio su cui stai lavorando, non tutta la pagina.',
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Le credenziali',
		},
	];
}
